import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ClienteModel } from 'src/app/models/cliente';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { PLANES_NO } from 'src/app/routes.constants';

@Component({
  selector: 'app-loading-no',
  standalone: false,
  templateUrl: './loading-no.component.html',
  styleUrl: './loading-no.component.scss'
})

export class LoadingNoComponent implements OnInit {
  minutos: number;
  segundos: number;
  id: any;
  private datosClienteHome!: ClienteModel;
  json: string = '';
  jsonFinal: string = '';
  leadId: string = '';
  codAsesor: string = '';
  IdBitacora: string = '';
  parametro: string = '';

  private datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }

  constructor(private router: Router, private route: ActivatedRoute) {
    this.minutos = 0;
    this.segundos = 8;
    this.id = setInterval(() => this.tick(), 3000);
  }

  private tick() {
    if (--this.segundos >= 0) {
      this.router.navigate([PLANES_NO, { codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: this.json, bitacoraId: this.IdBitacora }]);
    }
  }

  @Input() infoCliente?: string;
  @Input() idLead?: string;

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoCliente');
      this.codAsesor = params.getAll('codigoAsesor')[0];
      this.IdBitacora = params.getAll('bitacoraId')[0];

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosClienteHome = JSON.parse(this.jsonFinal);
        this.parametro = JSON.stringify(this.datosGenerales);
      }
      else {
        const paramInfoCliente = this.infoCliente;
        const paramIdLead = this.idLead;
        this.leadId = paramIdLead !== undefined ? paramIdLead : '';

        if (paramInfoCliente !== undefined) {
          this.json = paramInfoCliente;
          this.jsonFinal = atob(this.json);
          this.datosGenerales = JSON.parse(this.jsonFinal);
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.id) {
      clearInterval(this.id);
    }
  }

}
